import { defineMessages } from "react-intl";

import {
	iggMessages,
	validator
} from "lib/build/forms/htx/microbiological-procedures/hsv1Serology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hsv1Serology: {
		id: "form.hsv1_serology",
		defaultMessage: "HSV1"
	},
	igg: {
		id: "form.hsv1_serology.igg",
		defaultMessage: "IgG"
	}
});

const fields: { [key: string]: FieldData } = {
	igg: {
		type: "field",
		path: ["igg"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: iggMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.igg }] }]
};

export const node: LeafNode = {
	id: "hsv1Serology",
	value: {
		title: messages.hsv1Serology,
		validator,
		fieldset,
		isImportant: true
	}
};
